module.exports = __webpack_public_path__ + "static/media/wbgt-icon.4fd932b1.svg";